import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useColorMode } from '../../../../../../scss/js-helpers/getCurrentColorMode';
import PhoneDark from '../icons/phone-dark.svg';
import PhoneLight from '../icons/phone-light.svg';
import styles from './styles.module.scss';
export var PhoneBackground = function (_a) {
    var children = _a.children;
    var colorMode = useColorMode().colorMode;
    return (_jsxs("div", { className: styles['phone-background-wrapper'], children: [_jsx("div", { className: styles['phone-background'], children: colorMode === 'light' ? _jsx(PhoneLight, {}) : _jsx(PhoneDark, {}) }), _jsx("div", { className: styles['phone-background-content'], children: children })] }));
};
